import { register as ErrorService } from "src/pi/services/ErrorService";
import initData from "./Data";
import { register as ExceptionService } from "./Exception";

export default function register() {
    ErrorService();
    ExceptionService();
    initData();
}
